import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Stack,
    MenuItem,
    Snackbar,
    Alert,
    CircularProgress
} from '@mui/material'
import React, { useState } from 'react'
import { createCategory } from '../../../services/InventoryService'

const CategoryRegisterModal = ({ open, onClose, onRegisterSuccess }) => {
    const [category, setCategory] = useState({ name: '' })
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    })

    const validateFields = () => {
        const newErrors = {}
        if (!category.name) newErrors.name = 'Name is required'

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setCategory((prev) => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!validateFields()) return

        setLoading(true)
        try {
            const result = await createCategory(category)

            if (result?.error) {
                setSnackbar({
                    open: true,
                    message: result.error,
                    severity: 'error'
                })
            } else {
                setSnackbar({
                    open: true,
                    message: result.message || 'Category created successfully',
                    severity: 'success'
                })
                onRegisterSuccess()
                setCategory({ name: '', type: '' })
                onClose()
            }
        } catch (err) {
            setSnackbar({
                open: true,
                message: 'Something went wrong. Please try again.',
                severity: 'error'
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle fontWeight={600}>Register Category</DialogTitle>

                <DialogContent>
                    <Stack spacing={2} mt={1}>
                        <TextField
                            label="Category Name"
                            name="name"
                            fullWidth
                            value={category.name}
                            onChange={handleChange}
                            error={!!errors.name}
                            helperText={errors.name}
                        />
                    </Stack>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={onClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading}
                        startIcon={loading && <CircularProgress size={18} />}
                    >
                        {loading ? 'Saving...' : 'Register'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Snackbar Feedback */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    severity={snackbar.severity}
                    variant="filled"
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default CategoryRegisterModal
